// extracted by mini-css-extract-plugin
export var quantityInput = "_gv-0";